export default __webpack_public_path__ + "static/cta-banner-5c9da951ac7b00dac67ff0444a71c79a.webp";